import type { ConversationPriorityChangedEventData } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { ConversationTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import SettingsIcon from "@redotech/redo-icons/settings-02.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const ConversationPriorityChangedEvent = memo(
  function ConversationPriorityChangedEvent({
    event,
    data,
  }: {
    event: ConversationTimelineEventResponse;
    data: ConversationPriorityChangedEventData;
  }) {
    const prev = data.previousPriority ?? "none";
    const next = data.newPriority ?? "none";

    return (
      <Flex align="flex-start" className={styles.card} dir="row" gap="sm">
        <div className={styles.icon}>
          <SettingsIcon />
        </div>
        <Flex className={styles.content} dir="column" gap="xxs">
          <Text fontSize="xs">
            Priority changed from {prev} to {next}
          </Text>
          <EventTimestamp event={event} />
        </Flex>
      </Flex>
    );
  },
);
